"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ItemBonusModule = _interopRequireDefault(require("./ItemBonus.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemBonus = function ItemBonus(_ref) {
  var magicOpt = _ref.magicOpt;
  var opt = magicOpt.magicOpt,
      value = magicOpt.value;
  var i18nName = opt.i18nName,
      color = opt.color,
      isDecreasing = opt.isDecreasing,
      isPercentage = opt.isPercentage;
  var style = {
    color: color
  }; // TODO: i18n

  var text = "".concat(i18nName.en, " ").concat(isDecreasing ? "-" : "+").concat(value).concat(isPercentage ? "%" : "");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ItemBonusModule.default.itemBonus, !isDecreasing && _ItemBonusModule.default.isIncreasing, isDecreasing && _ItemBonusModule.default.isDecreasing),
    style: style
  }, text);
};

var _default = ItemBonus;
exports.default = _default;